import chroma from 'chroma-js';
import { isString } from './assertion';
export var toHoverColor = function (color) {
    if (!color)
        return '';
    return chroma(color).set('lab.l', '*0.8').hex();
};
export var toDisabledColor = function (color) {
    if (!color)
        return '';
    return chroma(color).alpha(0.5).hex();
};
export var isPercentageOrPixel = function (value) {
    return isString(value) ? value : "".concat(value, "px");
};
export var applyAlphaColor = function (color, alpha) {
    return chroma(color).alpha(alpha).hex();
};
